



















export default

	props:
		sections: Array
		current: String
		product: Array

	computed:

		quickShopProduct: -> if @product? then return @product

		productButton: -> {
			label: 'Quick Shop'
			product: @quickShopProduct?[0]
		}

	methods:
		go: (id) ->
			@$emit('go', id)


